<template>
  <div class="spec normalPage">
    <div class="pageTitle">
      <h1>推奨環境</h1>
      <div
        @click="backToTop"
        class="buttonMini buttonMini--circle38 backButton"
      >
        <img src="../assets/ui/back.png" width="8" height="14" alt="" />
      </div>
    </div>
    <div class="pageBody">
      <div>
        <p>
          本サイトを快適にご利用いただくために、以下の環境でのご利用をおすすめいたします。
          推奨以外の環境でご利用いただいた場合、画面が正常に表示されない、動作しない等の可能性があります。
        </p>
        <p>
          ※弊社が推奨するOS・ブラウザバージョンであっても、お客様が使用するブラウザのセキュリティ設定や、セキュリティソフトのご利用状況、環境やバージョンの組み合わせ、端末や端末設定によっては、弊社のサービスをご利用いただけない場合があります。
        </p>
      </div>
      <div>
        <h2>スマートフォンでのご利用について</h2>

        <p>
          対応OS : Android OS5.0.2以上、iOS11.3以上 <br />
          <span class="note"
            >※スマートフォンのみ。タブレット・ガラホは除く</span
          >
        </p>
        <p>
          対応ブラウザ : Android モバイル版Chrome（最新版）、 iPhone iOS
          safari（最新版） <br />
          ※複数の端末（またはブラウザ、タブ）でご覧の場合の動作保証はしておりません。あらかじめご了承ください。
        </p>
        <p>JavaScript : 有効にしてください。</p>
        <p>Cookie : 有効にしてください。</p>
        <p>
          補足事項 : iPhone、Android
          OS搭載端末（※タブレット端末・ガラホ端末・らくらくスマホ・サーバ証明書SHA-2対応ではない端末は非対応）でチケットぴあサービスのご利用が可能です。<br />
          スマートフォンで「<a href="http://t.pia.jp/">http://t.pia.jp/</a
          >」へアクセスし、スマートフォンサイトを表示の上、サービスをご利用ください。
        </p>

        <ul class="no-style">
          <li class="note">
            ※標準ブラウザ（スマートフォンに初期搭載されているブラウザ）以外ではご利用いただけません。
          </li>
          <li class="note">
            ※スマートフォンでPCサイトをご覧の場合の動作保証はしておりません。ご利用の際は、一部ページが正しく表示されない・操作できない場合がございますので、あらかじめご了承ください。
          </li>
          <li class="note">
            ※コンテンツブロッカーをお使いの場合、Cloakサイト等、一部ページにて正しく表示されない場合がございます。その場合はコンテンツブロッカーをオフにしていただいた上で、再度お試しください。
          </li>
        </ul>
      </div>
      <div class="backToTop">
        <div class="button"><a @click="backToTop">TOPに戻る</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import { setPage } from "../util/StoreUtil";

export default {
  name: "Spec",
  computed: {},
  methods: {
    backToTop() {
      setPage(null);
    }
  },
  mounted() {
    gtag("config", "UA-158811353-1", {
      page_title: "推奨環境",
      page_path: "/requirements"
    });
  }
};
</script>

<style scoped lang="sass">
@import "../sass/common"
@import "../sass/zindex"
.backButton
  img
    margin-left: -2px
.backToTop
    margin: 38px 0
    .button
        margin: auto
</style>
